import { render, staticRenderFns } from "./draw.vue?vue&type=template&id=904a1ac6&scoped=true"
import script from "./draw.vue?vue&type=script&lang=js"
export * from "./draw.vue?vue&type=script&lang=js"
import style0 from "./draw.vue?vue&type=style&index=0&id=904a1ac6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904a1ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('904a1ac6')) {
      api.createRecord('904a1ac6', component.options)
    } else {
      api.reload('904a1ac6', component.options)
    }
    module.hot.accept("./draw.vue?vue&type=template&id=904a1ac6&scoped=true", function () {
      api.rerender('904a1ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/institutionalWalletChild/child/draw.vue"
export default component.exports